import * as React from "react";
import { Menu, Icon} from "semantic-ui-react";
import { Link, withRouter } from "react-router-dom";
import { RouteComponentProps} from 'react-router';
import RestrictedRender from "../../../containers/RestrictedRender";
import { closeSideBar } from "../../../actions/navBar.actions";
import "./MobileSideNavBar.css";
import { State } from "../../../reducers";
import { connect } from "react-redux";
import { CommonUser } from "../../../types";
import { WithTranslation, withTranslation } from 'react-i18next';

interface MobileSideNavBarProps extends WithTranslation, RouteComponentProps {
    showSideNavBar: boolean;
    dispatch: any;
    user: CommonUser;
    handleLogOut?: () => void;
}
const mapStateToProps = (state: State) => (
    {
      user: state.authentication.user,
    }
  );
class MobileSideNavBar extends React.Component<MobileSideNavBarProps> {
    closeSideBar = () => {
        this.props.dispatch(closeSideBar());
    }
    adminItem = (currentPage: string) => {
        if (this.props.user.role.isAdmin)
            return (
                <Menu.Item className={currentPage == '/admin' ? 'selected' : ''}>
                    <RestrictedRender requiredRole="admin" />
                </Menu.Item>
            )
        return null;
    }
    render() {
        const currentPage = this.props.location.pathname;
        const menuItemNb = this.props.user.role.isAdmin ?3:2;
        return (
            <div className='mobileNavBar'>
                <Menu secondary fluid widths={menuItemNb}>
                    <Menu.Item className={currentPage=='/exercise-launcher' ?'selected':''} as={Link} to="/exercise-launcher">
                        <p> <Icon name="play" /> {String(this.props.t('navBar.exercise') || 'Exercise')}</p>
                    </Menu.Item>
                    <Menu.Item className={currentPage=='/profile' ?'selected':''} as={Link} to="/profile">
                        <p>  <Icon name="user" /> {String(this.props.t('navBar.profile') || 'Profile')}</p>
                    </Menu.Item>
                    {this.adminItem(currentPage)}
                </Menu>
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps)(withTranslation('common')(MobileSideNavBar)));